import ProductItem from "../BraceletProductItem/BraceletProductItem"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { shallowEqual, useSelector } from "react-redux"

function BraceletProductItem({ product, index }) {
  const maxItems = useSelector((state) => parseInt(state.stacker.maxItems, 10))
  const selectedList = useSelector(
    (state) => state.stacker.addedStack,
    shallowEqual
  )
  const swatch = useSelector((state) => state.swatch, shallowEqual)

  const { variants } = product
  let selected = false
  const selectedIndex = swatch[product.baseProduct]
    ? swatch[product.baseProduct].selectedVariantIndex
    : 0
  const selectedIndices = []
  variants.forEach((variant) => {
    if (selectedList.includes(variant.code)) {
      if (variants[selectedIndex].code === variant.code) {
        selected = true
      }
      selectedIndices.push(variant.code)
    }
  })
  const imgIndex = variants[selectedIndex].productImage
  const cropQuadrant = product.cropQuadrant
  const img = `${imgIndex}.jpg${cropQuadrant}`

  return (
    <ProductItem
      maxItems={maxItems}
      product={product}
      selected={selected}
      selectedIndex={selectedIndex}
      selectedIndices={selectedIndices}
      showSwatches
      src={img}
    />
  )
}

BraceletProductItem.propTypes = {
  product: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
}

export default BraceletProductItem
